import React from "react";
import Esports from "./Esports";
import SportsDraft from "./SportsDraft";
import Saas from "./Saas";
import CasualGames from "./Casualgames";
import Numbers from "./Number";
import Blogs from "../esports/Blogs";
import PRlinks from "./Prlinks";
import Footer from "../common/Footer";
import Banner from "./banner";
import Header from "../common/header";
const Gamerji = () => {
   

    return (
        <div className="w-full h-full bg-[#070B28]">
            <Header />

            <Banner />
            <Esports />
            <SportsDraft />
            <Saas />
            <CasualGames />
            <Numbers />
         
            <PRlinks />
            <Blogs />
            <Footer />
        </div>

    );
};

export default Gamerji;
